export default __webpack_public_path__ + "static/media/1.067e8ed2.png";